import { render, staticRenderFns } from "./PostsCreate.vue?vue&type=template&id=40e8ad3e&scoped=true"
import script from "./PostsCreate.vue?vue&type=script&lang=js"
export * from "./PostsCreate.vue?vue&type=script&lang=js"
import style0 from "./PostsCreate.vue?vue&type=style&index=0&id=40e8ad3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8ad3e",
  null
  
)

export default component.exports